import { fromJS } from "immutable";

import TYPE from "../../constants/type";

const initialState = fromJS({
  list: [],
  listById: [],
  listFiltered: [],
  isFetching: false,
  isFetchingAccepted: false,
  listDuplicate: [],
  isCheckingDuplicate: false,
});

export default function researchProposalReducer(state = initialState, action) {
  switch (action.type) {
    case TYPE.RESEARCH_PROPOSAL.GET_ALL_RESEARCH_PROPOSAL_LOADING:
    case TYPE.RESEARCH_PROPOSAL.GET_FILTERED_RESEARCH_PROPOSAL_LOADING:
    case TYPE.RESEARCH_PROPOSAL.GET_ALL_RESEARCH_PROPOSAL_BY_PROFILE_ID_LOADING:
    case TYPE.RESEARCH_PROPOSAL.INSERT_RESEARCH_PROPOSAL_LOADING:
    case TYPE.RESEARCH_PROPOSAL.UPDATE_RESEARCH_PROPOSAL_LOADING:
    case TYPE.RESEARCH_PROPOSAL.DELETE_RESEARCH_PROPOSAL_LOADING:
      return state.merge({
        isFetching: true,
      });

    case TYPE.RESEARCH_PROPOSAL.ACCEPT_RESEARCH_PROPOSAL_LOADING:
      return state.merge({
        isFetchingAccepted: true,
      });

    case TYPE.RESEARCH_PROPOSAL.GET_ALL_RESEARCH_PROPOSAL_FAILURE:
    case TYPE.RESEARCH_PROPOSAL.GET_FILTERED_RESEARCH_PROPOSAL_FAILURE:
    case TYPE.RESEARCH_PROPOSAL.GET_ALL_RESEARCH_PROPOSAL_BY_PROFILE_ID_FAILURE:
    case TYPE.RESEARCH_PROPOSAL.INSERT_RESEARCH_PROPOSAL_FAILURE:
    case TYPE.RESEARCH_PROPOSAL.UPDATE_RESEARCH_PROPOSAL_FAILURE:
    case TYPE.RESEARCH_PROPOSAL.DELETE_RESEARCH_PROPOSAL_FAILURE:
      return state.merge({
        isFetching: false,
      });

    case TYPE.RESEARCH_PROPOSAL.ACCEPT_RESEARCH_PROPOSAL_FAILURE:
      return state.merge({
        isFetchingAccepted: false,
      });

    case TYPE.RESEARCH_PROPOSAL.GET_ALL_RESEARCH_PROPOSAL_SUCCESS:
      return state.merge({
        list: action.payload || [],
        isFetching: false,
      });

    case TYPE.RESEARCH_PROPOSAL.GET_FILTERED_RESEARCH_PROPOSAL_SUCCESS:
      return state.merge({
        listFiltered: action.payload || [],
        isFetching: false,
      });

    case TYPE.RESEARCH_PROPOSAL.GET_ALL_RESEARCH_PROPOSAL_BY_PROFILE_ID_SUCCESS:
      return state.merge({
        listById: [...action.payload],
        isFetching: false,
      });

    case TYPE.RESEARCH_PROPOSAL.INSERT_RESEARCH_PROPOSAL_SUCCESS: {
      const newlistById = state.get("listById");
      const index = action.payload.researchProposalProfile.findIndex((e) => e.profileId === action.id);
      if (index >= 0) newlistById.push({ researchProposal: action.payload });
      return state.merge({
        listById: [...newlistById],
        listFiltered: [...state.get("listFiltered"), { researchProposal: action.payload }],
        isFetching: false,
      });
    }

    case TYPE.RESEARCH_PROPOSAL.UPDATE_RESEARCH_PROPOSAL_SUCCESS: {
      const newList = state.get("listFiltered");
      const index = newList.findIndex((e) => e.researchProposal.id === action.id);
      newList.splice(index, 1, { researchProposal: action.payload });

      const newList1 = state.get("listById");
      const index1 = newList1.findIndex((e) => e.researchProposal.id === action.id);
      newList1.splice(index1, 1, { researchProposal: action.payload });

      return state.merge({
        listFiltered: [...newList],
        listById: [...newList1],
        isFetching: false,
      });
    }

    case TYPE.RESEARCH_PROPOSAL.DELETE_RESEARCH_PROPOSAL_SUCCESS: {
      const newList = state.get("listFiltered");
      const index = newList.findIndex((e) => e.researchProposal.id === action.id);
      if (index !== -1) newList.splice(index, 1);

      const newList1 = state.get("listById");
      const index1 = newList1.findIndex((e) => e.researchProposal.id === action.id);
      if (index1 !== -1) newList1.splice(index1, 1);

      return state.merge({
        listFiltered: [...newList],
        listById: [...newList1],
        isFetching: false,
      });
    }

    case TYPE.RESEARCH_PROPOSAL.ACCEPT_RESEARCH_PROPOSAL_SUCCESS: {
      const newList = state.get("listById");
      const index = newList.findIndex((e) => e.researchProposal.id === action.payload.id);
      const newResearchProposal = { ...newList[index], researchProposal: action.payload };
      newList.splice(index, 1, newResearchProposal);

      const newList1 = state.get("listFiltered");
      const index1 = newList1.findIndex((e) => e.researchProposal.id === action.payload.id);
      const newResearchProposal1 = { ...newList1[index1], researchProposal: action.payload };
      newList1.splice(index1, 1, newResearchProposal1);

      return state.merge({
        listById: [...newList],
        listFiltered: [...newList1],
        isFetchingAccepted: false,
      });
    }

    case TYPE.RESEARCH_PROPOSAL.GET_DUPLICATE_RESEARCH_PROPOSAL_LOADING:
      return state.merge({ isCheckingDuplicate: true });
    case TYPE.RESEARCH_PROPOSAL.GET_DUPLICATE_RESEARCH_PROPOSAL_SUCCESS:
      return state.merge({ listDuplicate: action.payload ?? [], isCheckingDuplicate: false });
    case TYPE.RESEARCH_PROPOSAL.GET_DUPLICATE_RESEARCH_PROPOSAL_FAILURE:
      return state.merge({ isCheckingDuplicate: false });

    default:
      return state;
  }
}

